import { initMenuAccordions } from "./menu-accordion";
import { initAccordions } from "./accordion";
import { headerScrolled } from "./header-scrolled";
import { initSliders, initUpsellSlider } from "./sliders";
import { recommendedProducts } from "./upsells";

customElements.define("recommended-products", recommendedProducts);

document.addEventListener("DOMContentLoaded", function () {
    initMenuAccordions()
    initAccordions()
    headerScrolled()
    initSliders()
});

document.addEventListener("upsell:loaded", (e) => {
  initUpsellSlider();
});

document.addEventListener('change', function (e) {
  const changedVariantInput = e.target.matches('input.options-selection__option-value-input');

  if (changedVariantInput) {
    setTimeout(() => {
      initSliders();
    }, 1500);
  }
});
